<template>
  <div>
    <DesktopFullVideo v-if="commonStore.isDesktop" />
    <MobileFullVideo v-else />
  </div>
</template>

<script setup lang="ts">
import DesktopFullVideo from '@components/desktop/base/DesktopFullVideo.vue';
import MobileFullVideo from '@components/mobile/base/MobileFullVideo.vue';
import { useCommonStore } from '@stores';
const commonStore = useCommonStore();
</script>

<style scoped lang="scss"></style>
